const customFooterClass = "footer";
const EditorClasses = {
  Anchor: "t-editor__anchor",
  Bold: "t-editor__bold",
  Button: "t-editor__button",
  Callout: "t-editor__callout",
  Card: "t-editor__card",
  CheckList: "t-editor__checklist",
  Code: "t-editor__code",
  CodeContainer: "t-editor__code-container",
  CodeGroup: "t-editor__code-group",
  CodeMirror: "t-editor__codemirror",
  Column: "t-editor__column",
  Detail: "t-editor__detail",
  Editor: "t-editor",
  Embed: "t-editor__embed",
  File: "t-editor__file",
  FinePrint: "t-editor__fine-print",
  Grid: "t-editor__grid",
  Group: "t-editor__group",
  Heading: "t-editor__heading",
  Highlight: "t-editor__highlight",
  Icon: "t-editor__icon",
  IconError: "t-editor__detail-icon--error",
  Image: "t-editor__image",
  InlineCode: "t-editor__inline-code",
  Italic: "t-editor__italic",
  LanguagePicker: "t-editor__language-picker",
  LineBreak: "t-editor__line-break",
  List: "t-editor__list",
  Mark: "t-editor__mark",
  Math: "t-editor__math",
  Mermaid: "t-editor__mermaid",
  PageLink: "t-editor__page-link",
  PageTitle: "t-editor__page-title",
  Paragraph: "t-editor__paragraph",
  Pill: "t-editor__pill",
  Quote: "t-editor__quote",
  Row: "t-editor__row",
  Step: "t-editor__step",
  Steps: "t-editor__steps",
  Strike: "t-editor__strike",
  Subscript: "t-editor__subscript",
  Superscript: "t-editor__superscript",
  Table: "t-editor__table",
  Tabs: "t-editor__tabs",
  Underline: "t-editor__underline"
};
export {
  EditorClasses,
  customFooterClass
};
//# sourceMappingURL=styles.js.map
